import script from "./SignupPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignupPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SignupPanel.vue?vue&type=style&index=0&id=49482908&lang=scss&scoped=true"
import "./SignupPanel.vue?vue&type=style&index=1&id=49482908&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49482908"]])

export default __exports__